export const normalizeLeadingInteger = (value: unknown): string => {
  if (value === null || value === undefined) return ''

  const text = String(value)
  if (!text) return ''

  return text.replace(/^([+-]?)0+(?=\d)/, '$1')
}

export const normalizeMaterialJpl = (value: unknown): string =>
  normalizeLeadingInteger(value).trim()
